import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { canLogEvents } from '@/utils/canLogEvents';

import { OnboardingFooter } from '../../../../components/Footer';
import { OnboardingPage } from '../../../../components/Page';
import { OnboardingSubtitle } from '../../../../components/Subtitle';
import { OnboardingTitle } from '../../../../components/Title';
import { AI_DATA } from '../../../../constants';
import { useOnboarding } from '../../../../context';

import './DressUp.scss';

export const OnboardingReplikaDressUp: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'DressUp',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <OnboardingPage className="onboarding-dress-up">
      <IonContent>
        <div className="img-container">
          <img
            src={AI_DATA[webCampaign.aiType].dressUp.imageSrc}
            alt="relationships"
          />
        </div>
        <OnboardingTitle className="onboarding-dress-up__title">
          Dress Up Characters
        </OnboardingTitle>
        <OnboardingSubtitle>
          Gift outfits to your favorite characters and get a photo of them
          wearing it!
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingPage>
  );
};
